module.exports = __webpack_public_path__ + "static/media/03 product.fc480410.jpg";